module.exports = __webpack_public_path__ + "img/orderanalysis.c0443ea1.svg";